import DatafieldSection, {
  DatafieldLabel,
} from "../../../components/datafield-section";
import { WriteOffMetaData } from "../../../models";
import { dateToDDMMYYYY } from "../../../utils";
import { WriteOffCollectionAmount } from "../types";

interface WrittenOffDetailsProps {
  data: WriteOffMetaData;
  writeOffCollectionAmount: WriteOffCollectionAmount | null;
}

const WrittenOffDetailsLables: DatafieldLabel[] = [
  {
    items: [
      {
        label: "Date:",
        key: "date",
        formatMethod: (value: string) => dateToDDMMYYYY(value),
      },
    ],
  },
];

export default function WrittenOffDetails({
  data,
  writeOffCollectionAmount,
}: WrittenOffDetailsProps) {
  const combinedData = {
    ...data,
    writeOffCollectionAmount: writeOffCollectionAmount || {
      totalPostWriteoffCollectionAmount: 0,
    },
  };

  return (
    <div>
      <h3 className="user-page-title mb-4">Written off & Settlement details</h3>
      <DatafieldSection
        className="mt-4"
        labels={WrittenOffDetailsLables}
        data={combinedData}
      />
    </div>
  );
}
